import { render } from "./ReleaseRegistryComponent.vue?vue&type=template&id=19ef6d84&scoped=true"
import script from "./ReleaseRegistryComponent.vue?vue&type=script&lang=js"
export * from "./ReleaseRegistryComponent.vue?vue&type=script&lang=js"

import "./ReleaseRegistryComponent.vue?vue&type=style&index=0&id=19ef6d84&scoped=true&lang=scss"

import exportComponent from "/Users/dmitriy-pc/Projects/ds-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19ef6d84"]])

export default __exports__